import { graphql } from '../graphql';

export const updateProjectMutation = graphql(`
  mutation UpdateProject($input: UpdateProjectInput!) {
    updateProject(input: $input) {
      id
      name
      description
      srid
      defaultThirdPersonView
      flatContentMode
      flatContentHeight
      flatContentDrapeLayerId
    }
  }
`);

export const createProjectLinkMutation = graphql(`
  mutation CreateProjectLink(
    $projectId: ID!
    $expiresAt: DateTime!
    $name: String!
    $password: String
    $allowQuickUploads: Boolean
    $allowFindings: Boolean
    $groupLayersByType: Boolean
  ) {
    createProjectLink(
      projectId: $projectId
      expiresAt: $expiresAt
      name: $name
      password: $password
      allowQuickUploads: $allowQuickUploads
      allowFindings: $allowFindings
      groupLayersByType: $groupLayersByType
    ) {
      id
      projectId
      token
      hasPassword
      expiresAt
      createdAt
      createdById
      allowQuickUploads
      allowFindings
      groupLayersByType
      createdBy {
        id
        name
        email
      }
    }
  }
`);

export const updateProjectLinkPasswordMutation = graphql(`
  mutation UpdateProjectLinkPassword($id: ID!, $password: String) {
    updateProjectLinkPassword(id: $id, password: $password) {
      id
      hasPassword
    }
  }
`);

export const updateProjectLinkAllowQuickUploadsMutation = graphql(`
  mutation UpdateProjectLinkAllowQuickUploads($id: ID!, $allowQuickUploads: Boolean!) {
    updateProjectLinkAllowQuickUploads(id: $id, allowQuickUploads: $allowQuickUploads) {
      id
      allowQuickUploads
    }
  }
`);

export const updateProjectLinkAllowFindingsMutation = graphql(`
  mutation UpdateProjectLinkAllowFindings($id: ID!, $allowFindings: Boolean!) {
    updateProjectLinkAllowFindings(id: $id, allowFindings: $allowFindings) {
      id
      allowFindings
    }
  }
`);

export const updateProjectLinkGroupLayersByTypeMutation = graphql(`
  mutation UpdateProjectLinkGroupLayersByType($id: ID!, $groupLayersByType: Boolean!) {
    updateProjectLinkGroupLayersByType(id: $id, groupLayersByType: $groupLayersByType) {
      id
      groupLayersByType
    }
  }
`);

export const deleteProjectLinkMutation = graphql(`
  mutation DeleteProjectLink($id: ID!) {
    deleteProjectLink(id: $id)
  }
`);

export const deleteProjectMutation = graphql(`
  mutation DeleteProject($id: ID!) {
    deleteProject(id: $id)
  }
`);

export const archiveProjectMutation = graphql(`
  mutation ArchiveProject($id: ID!) {
    archiveProject(id: $id) {
      id
      archiveStatus
      archiveRequestedAt
    }
  }
`);

export const restoreProjectMutation = graphql(`
  mutation RestoreProject($id: ID!) {
    restoreProject(id: $id) {
      id
      archiveStatus
      restoreRequestedAt
      restoreExpiresAt
    }
  }
`);

export const deleteArchivedProjectMutation = graphql(`
  mutation DeleteArchivedProject($id: ID!) {
    deleteArchivedProject(id: $id)
  }
`);

export const addProjectBaseMapMutation = graphql(`
  mutation AddProjectBaseMap($projectId: ID!, $input: CustomBaseMapInput!) {
    addProjectBaseMap(projectId: $projectId, input: $input) {
      id
      baseMaps {
        id
        name
        type
        url
        tileSize
        wmsVersion
        wmsLayers
        format
      }
    }
  }
`);

export const updateProjectBaseMapMutation = graphql(`
  mutation UpdateProjectBaseMap($projectId: ID!, $baseMapId: ID!, $input: CustomBaseMapInput!) {
    updateProjectBaseMap(projectId: $projectId, baseMapId: $baseMapId, input: $input) {
      id
      baseMaps {
        id
        name
        type
        url
        tileSize
        wmsVersion
        wmsLayers
        format
      }
    }
  }
`);

export const deleteProjectBaseMapMutation = graphql(`
  mutation DeleteProjectBaseMap($projectId: ID!, $baseMapId: ID!) {
    deleteProjectBaseMap(projectId: $projectId, baseMapId: $baseMapId) {
      id
      baseMaps {
        id
        name
        type
        url
        tileSize
        wmsVersion
        wmsLayers
        format
      }
    }
  }
`);
